<script>
    export let options, height = 'auto', show=false, type, button_id, auto_width=false, selected_callback=()=>{}

    let top='0px', left='0px', width='0px';

    function MenuDropDownButton(button, args=null){
        console.log('Dropdown menu button pressed: ' + button + ' with args: ' + args)
        if(button == 'Import'){
            selected_callback()
        }else if(button == 'Export'){
            selected_callback()
        }else if(button == 'Something'){
            selected_callback()
        }else if(button == 'unit_type'){
            selected_callback(args)
        }
    }

    function GetLocationOfElement(id) {
        //console.log(element)
        var element = document.getElementById(id)
        var bodyRect = document.body.getBoundingClientRect(),
            elemRect = element.getBoundingClientRect(),
            y = elemRect.height - bodyRect.top,
            x = elemRect.left - bodyRect.left,
            w = elemRect.width;

        //console.log(button_id)
        //console.log({ top: y, left: x })
        return { top: y, left: x , width: w};
    }

    window.addEventListener("load", ()=>{
        var offsets = GetLocationOfElement(button_id)
        left = Math.round(offsets.left) + 'px'
        top = Math.round(offsets.top) + 'px'
        width = Math.round(offsets.width) + 'px'
    }, false)
    
</script>


<div class="custom_dropdown_units" style="--left:{left}; --top:{top}; --width:{auto_width ? 'auto' : width}; {show ? 'height:'+height : 'height: 0px;'}" >
    {#each options as option, i}
        {#if type=='menu'}
            <button on:click={() => {MenuDropDownButton(option)}}>{option}</button>
        {:else if type=='units'}
            <button on:click={() => {MenuDropDownButton('unit_type',option)}}>{option}</button>
        {/if}

        {#if i < options.length-1}
            <div class="line"></div>
        {/if}
    {/each}
</div>

<style lang="scss">
    @use "./styles/global.scss";

    .custom_dropdown_units{
        font: inherit;
        font-size: 18px;
        @include custom_dropdown();
        position: absolute;
        z-index: 7;
        left: var(--left);
        top: var(--top);
        width: var(--width);
    }

    .line{
        width: 70%;
        height: 1px;
        color: $grey5;
    }

</style>